<template>
  <div>
    <div class="con-list f-clearfix teacher-card">
      <ul class="index-teacher f-clearfix">
        <li
          v-for="(item, index) in tableList"
          :key="index"
          :title="item.name"
          @click="toDetail(item)"
        >
          <div class="item-msg">
            <div class="item-img">
              <img v-img.lazy="getUrl(item.avatar)" :alt="item.realName" />
            </div>
            <h3>{{ item.realName }}</h3>
            <div class="item-title">
              <p>{{ item.schoolName }}</p>
              <p>{{ item.jobTitleName }}</p>
            </div>
            <div class="item-datas">
              <!-- <span class="item-course">课程：{{ item.courseCount }}</span> -->
              <span
                class="item-edu"
                style="text-align: center; padding-right: 0px"
              >
                {{ item.studentCount || 0 }}人选课
              </span>
            </div>
          </div>
          <div
            class="item-details"
            v-if="item.introduction"
            v-html="item.introduction"
          ></div>
          <div class="item-details item-no-data" v-else>
            <p>暂无教师简介</p>
          </div>
        </li>
      </ul>
      <div class="item-flex"></div>
      <div class="icon-btn icon-btn-left" @click="pageLeft('left')">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="icon-btn icon-btn-right" @click="pageLeft('right')">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
      teacherList: [],
      teacherWebLIst: [],
      name: 1,
      pageFlag: 1,
      imgUrl: this.$setting.fdsDomain,
    };
  },
  mounted() {
    this.name = this.$route.query.siteId || 1;
    this.getList();
  },
  methods: {
    getUrl(url) {
      if (!url) {
        return url;
      }
      if (url.startsWith("http")) {
        return url;
      } else {
        return this.imgUrl + url;
      }
    },
    toDetail(val) {
      window.open(`${val.linkUrl}`);
    },
    pageLeft(val) {
      if (val == "left") {
        if (this.pageFlag > 1) {
          this.tableList = [];
          let item = [];
          this.pageFlag--;
          for (let i = (this.pageFlag - 1) * 5; i < this.pageFlag * 5; i++) {
            item.push(this.teacherWebLIst[i]);
          }
          this.tableList = item;
        }
      } else {
        if (this.pageFlag < Math.ceil(this.teacherWebLIst.length / 5)) {
          this.tableList = [];
          let item = [];
          for (let j = this.pageFlag * 5; j < (this.pageFlag + 1) * 5; j++) {
            if (j < this.teacherWebLIst.length) {
              item.push(this.teacherWebLIst[j]);
            }
          }
          this.tableList = item;
          this.pageFlag++;
        }
      }
    },
    getList() {
      let par = {
        siteId: this.name,
        type: 3,
      };
      this.$http
        .get("/api/manager/customize/getInfo", { params: par })
        .then((res) => {
          this.tracherList = JSON.parse(res.data.content) || [];
          let ids = [];
          for (let i = 0; i < this.tracherList.length; i++) {
            ids.push(this.tracherList[i].teacherId);
          }
          this.getWebList(ids);
          this.$emit("getTeacher", this.tracherList.length > 0);
        })
        .catch((msg) => {});
    },
    getWebList(ids) {
      let par = {
        ids: ids.toString(),
      };
      this.$http
        .get("/api/web/teacher/getDetails", { params: par })
        .then((res) => {
          this.teacherWebLIst = res.data;
          for (let i = 0; i < 5; i++) {
            if (i < this.teacherWebLIst.length) {
              if (
                this.teacherWebLIst[i].linkUrl != "" &&
                this.teacherWebLIst[i].linkUrl != null
              ) {
                this.teacherWebLIst[i].linkUrl = this.teacherWebLIst[
                  i
                ].linkUrl.replace("/spoc/", "/");
              }
              this.tableList.push(this.teacherWebLIst[i]);
            }
          }
        })
        .catch((msg) => {});
    },
  },
};
</script>
<style lang="scss">
.g-bd {
  background: #f7f8f9;
}
.teacher-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  position: relative;
  .item-flex {
    flex: 1;
    min-width: 70px;
    max-width: 70px;
  }
  .icon-btn {
    position: absolute;
    top: 185px;
    font-size: 32px;
    color: #fff;
    line-height: 60px;
    cursor: pointer;
    i {
      display: inline-block;
      background: #f5f6f933;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
    }
    &:hover {
      color: #3685fd;
    }
  }
  .icon-btn-left {
    left: -60px;
  }
  .icon-btn-right {
    right: -60px;
  }
}
.index-teacher {
  margin-top: 90px;
  overflow: hidden;
  white-space: nowrap;
  margin: 30px 0;
  min-width: 1200px;
  :nth-child(5n) {
    margin-right: 0px;
  }
  li {
    float: left;
    width: 216px;
    margin-right: 30px;
    margin-top: 50px;
    border-radius: 4px;
    background: #fff;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    .item-msg {
      position: relative;
      background: #f0f2f7;
      padding: 65px 0 14px 0;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
    }
    h3 {
      font-size: 18px !important;
    }
    .item-title {
      p {
        height: 30px;
        padding-bottom: 12px;
        text-align: center;
        font-size: 14px;
        color: #777;
      }
    }
    .item-img {
      position: absolute;
      left: 53px;
      top: -50px;
      width: 110px;
      height: 110px;
      border-radius: 50%;
      border: solid 3px #fff;
      overflow: hidden;
      margin: 0 auto;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
        transition: all 0.2s ease-in-out;
      }
    }
    h3 {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 40px;
      text-align: center;
    }
    .item-datas {
      display: flex;
      span {
        flex: 1;
        color: #777;
        font-size: 12px;
      }
      .item-course {
        float: left;
        text-align: left;
        padding-left: 40px;
      }
      .item-edu {
        float: right;
        text-align: right;
        padding-right: 40px;
      }
    }
    .item-details {
      color: #333;
      font-size: 14px;
      text-align: left;
      margin: 15px 20px;
      height: 38px;
      overflow: hidden;
      white-space: normal;
      &.item-no-data {
        color: #777;
        text-align: center;
        font-size: 12px;
      }
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }
    &:hover {
      // transform: translate3d(0, -2px, 0);
      cursor: pointer;
      img {
        opacity: 0.8;
        transform: scale(1.1);
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
</style>


